<template>
    <div class="fw-billing">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="fwb-top">
            <div class="fwbt-s">
                <div class="fwbt-item" >
                    <span class="fwbt-c1">{{deptName}}</span>
                </div>
                <div class="fwbt-item" >
                <span class="fwbt-c1" @click="toAddMember">创建客户+</span>
                </div>
                <div class="fwbt-item" >
                    <span class="fwbt-c1" @click="toMembers">选择会员</span>
                </div>
                <div class="fwbt-item" style="border-right: #EEEEEE solid 0px">
                    <span class="fwbt-c" v-if="serviceName">{{serviceName}}</span>
                </div>
            </div>
            <div class="fwbt-x">
                <div class="fwbt-item1" @click="toXfs">
                    <span class="fwbt-t1" v-if="member&&member.id">{{member.memberName}}</span>
                    <span class="fwbt-t1" v-if="!member||!member.id">散客</span>
                    <span class="fwbt-b">客户名称</span>
                </div>
                <div class="fwbt-item1" v-if="mbCard&&mbCard.id">
                    <span class="fwbt-t1">{{mbCard.cardName}}</span>
                    <span class="fwbt-b">{{mbCard.balance}}</span>
                </div>
                <div class="fwbt-item2" v-if="member&&member.id" @click="toMdItems">
                    套餐
                </div>
                <div class="fwbt-item2" style="border-right: #EEEEEE solid 0px" v-if="member&&member.id" @click="toScItems">
                    商城
                </div>
            </div>
        </div>
        <div class="fw-kdtype" ref="kdtype">
            <div class="fw-leibie">
                <span :class="{'lbActive':lbIndex==0}" class="names"  @click="setType(0)" >项目</span>
                <span :class="{'lbActive':lbIndex==1}" class="names"  @click="setType(1)" >商品</span>
                <span :class="{'lbActive':lbIndex==2}" class="names"  @click="setType(2)" >成品</span>
            </div>
            <Items ref="itemTab" v-if="lbIndex==0" @toItemChoose="toItemChoose" :mbCard="mbCard" :kdStyle="kdStyle" :style="kdStyle"/>
            <Skus  ref="skuTab"  v-if="lbIndex==1" @toSkuChoose="toSkuChoose"   :mbCard="mbCard" :kdStyle="kdStyle" :style="kdStyle"/>
            <Specs ref="specTab" v-if="lbIndex==2" @toSpecChoose="toSpecChoose" :memberId="member.id" :kdStyle="kdStyle" :style="kdStyle"/>
        </div>
        <div class="fw-btn" v-if="isEmp==1">
            <div class="mingxi" @click="toMx">
                <div class="mingxi-text">
                    <span style="font-size: 13px">明细查看</span>
                    <span style="margin-top: 5px;font-size: 20px">
                    <span style="font-size: 10px;margin-right: 5px">¥</span>{{total}}</span>
                </div>
            </div>
            <div class="baocun" @click="saveOrder">
                <span class="baocun-btn">{{loading==false?'保存并返回':'正在保存'}}</span>
            </div>
        </div>
        <div class="fw-btn" v-if="isEmp==0">
            <div class="mingxi1" @click="toMx">
                <div class="mingxi-text1">
                    <span style="font-size: 13px">明细查看</span>
                    <span style="margin-top: 5px;font-size: 20px">
                    <span style="font-size: 10px;margin-right: 5px">¥</span>{{total}}</span>
                </div>
            </div>
            <div class="baocun1" @click="saveOrder">
                {{loading==false?'保存并返回':'正在保存'}}
            </div>
            <div class="jiesuan1" >
                <span class="jiesuan-btn1" @click="toPay"> 结算</span>
            </div>
        </div>
        <van-popup v-model="mxShow" position="bottom" closeable lock-scroll overlay style="height: 90%;">
            <div style="padding: 15px;">
                <div class="fw-mx">
                    <span style="font-size: 15px">服务号:
                        <span style="color:red;font-size: 13px"> {{serviceName==null?serviceNo:serviceName}}</span>
                    </span>
                    <div class="fw-mx-nr">
                        <span class="membername" v-if="member&&member.id">{{member.memberName}}</span>
                        <span style="height: 32px;font-size: 15px;line-height: 32px"
                              v-if="!member||!member.id">散客</span>
                        <van-tabs class="kdtab" v-model="activeName">
                            <van-tab title="项目">
                                <div class="fw-mx-items">
                                    <div class="fw-mx-item" v-for="(item,index) in items">
                                        <div class="fwmxi-info">
                                            <span class="fm-name">{{item.itemName}}</span>
                                            <span class="fm-jg">¥{{item.price}}</span>
                                            <span class="fm-num">x1</span>
                                            <span class="fm-btn" @click="delData(index,1)">删除</span>
                                        </div>
                                        <span class="mxemp" v-if="fName">{{fName}}: {{item.femp.empName}} </span>
                                        <span class="mxemp" v-if="sName">{{sName}}: {{item.semp.empName}}</span>
                                        <span class="mxemp" v-if="tName">{{tName}}: {{item.temp.empName}}</span>
                                    </div>
                                </div>
                            </van-tab>
                            <van-tab title="商品">
                                <div class="fw-mx-items">
                                    <div class="fw-mx-item" v-for="(item,index) in skus">
                                        <div class="fwmxi-info">
                                            <span class="fm-name">{{item.itemName}}</span>
                                            <span class="fm-jg">¥{{item.price}}</span>
                                            <span class="fm-num">x1</span>
                                            <span class="fm-btn" @click="delData(index,2)">删除</span>
                                        </div>
                                        <span class="mxemp" v-for="emp in item.emps">{{emp.empName}} </span>
                                    </div>
                                </div>
                            </van-tab>
                            <van-tab title="成品">
                                <div class="fw-mx-items">
                                    <div class="fw-mx-item" v-for="(item,index) in specs">
                                        <div class="fwmxi-info">
                                            <span class="fm-name">{{item.itemName}} <span style="margin-left: 5px">{{item.spec}}</span></span>
                                            <span class="fm-jg">¥{{item.price}}</span>
                                            <span class="fm-num">x1</span>
                                            <span class="fm-btn" @click="delData(index,3)">删除</span>
                                        </div>
                                        <span class="mxemp" v-for="emp in item.emps">{{emp.empName}} </span>
                                    </div>
                                </div>
                            </van-tab>
                        </van-tabs>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="mbShow" position="bottom" closeable lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 100%;">
            <Memmbers ref="mbs" @setMember="setMember" @sanke="sanke" />
        </van-popup>
        <van-popup v-model="tcShow" position="bottom" closeable lock-scroll :close-on-click-overlay="false"
                   style="height: 100%;">
            <Tcs ref="tcs" @guanbi="guanbi"/>
        </van-popup>
        <van-popup v-model="scShow" position="bottom" closeable lock-scroll :close-on-click-overlay="false" style="height: 100%;">
            <Scs ref="scs" @guanbi="guanbi"/>
        </van-popup>
        <van-popup v-model="addShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <AddMemmber ref="addmb" @gbMember="gbMember" :addType="addType"/>
        </van-popup>
        <van-popup v-model="jsShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 77%;">
            <Pay v-if="jsShow" ref="pay" @gbPay="gbPay" :payItem="payItem"/>
        </van-popup>
        <van-popup v-model="xkShow" position="bottom" lock-scroll closeable overlay :close-on-click-overlay="false" style="height: 100%;overflow:hidden;">
            <Xk v-if="xkShow" ref="xk" @gbXk="gbXk"  :memberId="memberId"/>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";
    import AddMemmber from "../common/addMember";
    import Memmbers from "../common/members";
    import Pay from "../common/pay";
    import Xk from "../customer/center/recharge";
    import Items from "./list/items";
    import Skus from "./list/skus";
    import Specs from "./list/specs";
    import Tcs from "./list/tcs";
    import Scs from "./list/scs";

    export default {
        components: {AddMemmber,Memmbers,Items,Skus,Specs,Tcs,Scs,Pay,Xk},
        data() {
            return {
                title: '开单选项',
                deptId: '',
                deptName:'',
                userType: '',
                roomId: '',
                token: '',
                active: 0,
                list: [],
                gwJb: {},
                room: {},
                tabIndex: 0,
                lbIndex: '0',
                serviceName: '',
                serviceNo: '',

                items: [],
                skus: [],
                specs: [],
                total: 0,

                fName: '',
                sName: '',
                tName: '',

                addType: 'kd',
                addShow: false,
                activeName:0,
                mxShow: false,
                mbShow: false,
                members: [],
                member: {},
                mbCard: {},
                memberId: '',
                mcId: '',
                add: 0,

                tcShow: false,
                scShow: false,

                loading:false,
                isEmp:1,

                jsShow:false,
                payItem:{},

                xkShow:false,
                kdStyle:'',
            };
        },
        async mounted() {
            document.title = "数字智慧助手"
            let kdtype=this.$refs.kdtype
            this.kdStyle='height:'+(kdtype.offsetHeight-85)+'px'
            this.orderId = this.$route.params.orderId
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.deptName = this.fwUser.deptName
            this.userType = this.fwUser.userType
            this.token = this.fwUser.token
            this.getDept()
            this.getFwRoomNo()
            this.getFwGrade()
            this.getFwEmps()
            await this.getOrderInfo()
            this.initMbCard(this.mbCard)

        },
        methods: {
            toXk(){
                if (this.mbCard&&this.mbCard.id){
                    this.memberId=this.member.id
                    this.xkShow=true
                }
            },
            gbXk(){
                this.getMember()
                this.xkShow=false
            },
            toAddMember() {
                this.addShow = true
                if (this.$refs.addmb) {
                    this.$refs.addmb.chushi();
                }
            },
            gbMember(member) {
                this.member = member
                this.addShow = false
            },

            toMembers(){
                this.mbShow = true
                if (this.$refs.mbs){
                    this.$refs.mbs.chushi();
                }
            },
            toMdItems(){
                if (!this.member.id) {
                    return;
                }
                this.tcShow=true
            },
            toScItems(){
                if (!this.member.id) {
                    return;
                }
                this.scShow=true
            },

            //查询订单信息
            async getOrderInfo() {
                let res = await this.$get("/sw/getSwOrder", {orderId: this.orderId});
                this.add = res.add
                if (res.order.itemStr) {
                    this.items = JSON.parse(res.order.itemStr)
                    this.items.forEach(item => {
                        this.total = parseFloat(this.total) + parseFloat(item.price)
                    })
                }
                if (res.order.skuStr) {
                    this.skus = JSON.parse(res.order.skuStr)
                    this.skus.forEach(item => {
                        this.total = parseFloat(this.total) + parseFloat(item.price)
                    })
                }
                if (res.order.specStr) {
                    this.specs = JSON.parse(res.order.specStr)
                    this.specs.forEach(item => {
                        this.total = parseFloat(this.total) + parseFloat(item.price)
                    })
                }
                if (res.member) {
                    this.member = res.member
                }
                if (res.mbCard) {
                    this.mbCard = res.mbCard
                }
                this.memberId = res.order.memberId
                this.mcId = res.order.mcId
            },
            async getFwRoomNo() {
                let data = {
                    orderId: this.orderId,
                }
                let res = await this.$get("/fw/getFwRoomNo", data)
                this.serviceName = res.serviceName
                this.serviceNo = res.serviceNo
            },
            async getDept() {
                let res = await this.$get("/fw/getFwDeptInfo", {id: this.deptId});
                if (res.dept.isEmp!=null){
                    this.isEmp=res.dept.isEmp
                }
            },
            async getFwGrade() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwGrade", data)
                if (res.dgj && res.dgj.gradeName) {
                    this.title = this.title + ' / ' + res.dgj.gradeName
                }
            },
            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },

            setType(lbIndex) {
                this.lbIndex = lbIndex
            },

            sanke() {
                this.member = {}
                this.mbCard = {}
                this.sankejiage()
                this.mbShow = false
            },

            setMember(data) {
                if (data.mb && data.mb.id) {
                    this.member = data.mb
                    this.memberId = data.mb.id
                }
                if (data.card && data.card.id) {
                    this.mbCard = data.card
                    this.mcId = data.card.id
                    this.huiyuanjiage()
                }
                let total=parseFloat(this.total)
                this.total = total.toFixed(1)
                this.mbShow = false
            },

            delData(index,type) {
                if (type==1){
                    let item = this.items[index];
                    this.items.splice(index, 1)
                    var to = parseFloat(this.total) - parseFloat(item.price);
                    this.total = to.toFixed(1)
                }
                if (type==2){
                    let item = this.skus[index];
                    this.skus.splice(index, 1)
                    var to = parseFloat(this.total) - parseFloat(item.price);
                    this.total = to.toFixed(1)
                }
                if (type==3){
                    let item = this.specs[index];
                    this.specs.splice(index, 1)
                    var to = parseFloat(this.total) - parseFloat(item.price);
                    this.total = to.toFixed(1)
                }
            },

            toMx() {
                if (this.items.length > 0||this.skus.length>0||this.specs.length>0) {
                    this.mxShow = true
                } else {
                    this.$notify("没添加任何商品!");
                }
            },


            async saveOrder() {
                if (this.loading){
                    return ;
                }
                this.loading = true
                let mcId = ''
                if (this.mbCard && this.mbCard.id) {
                    mcId = this.mbCard.id
                }
                let memberId = ''
                let orderSex = 1
                if (this.member && this.member.id) {
                    memberId = this.member.id
                    orderSex = this.member.sex
                }
                var data = {
                    orderId: this.orderId,
                    itemStr: JSON.stringify(this.items),
                    skuStr: JSON.stringify(this.skus),
                    specStr: JSON.stringify(this.specs),
                    total: this.total,
                    memberId: this.memberId,
                    mcId: mcId,
                    orderSex: orderSex,
                    token: this.token,
                    deptId: this.deptId,
                }
                let res = await this.$post("/sw/updateBillingOrder", data);
                if (res.code == 200) {
                    this.$router.push('/home')
                    // this.loading = false
                    // this.$router.go(-1)
                    // this.$message.success(res.message);
                } else {
                    this.loading = false
                    this.$message.error(res.message);
                }
            },
            toPay(){
                if (this.items.length > 0 || this.skus.length > 0 || this.specs.length > 0) {
                    let mcId = ''
                    if (this.mbCard && this.mbCard.id) {
                        mcId = this.mbCard.id
                    }
                    let memberId = ''
                    let orderSex = 1
                    if (this.member && this.member.id) {
                        memberId = this.member.id
                        orderSex = this.member.sex
                    }
                    var data = {
                        itemStr: JSON.stringify(this.items),
                        skuStr: JSON.stringify(this.skus),
                        specStr: JSON.stringify(this.specs),
                        token:this.token,
                        total: this.total,
                        orderId: this.orderId,
                        memberId: memberId,
                        mcId: mcId,
                        orderSex: orderSex,
                        fwType:'fw'
                    }
                    this.data=data
                    this.payItem={
                        orderType:'qd',
                        data:data,
                        totalStr:this.total.toString(),
                    }
                    if(this.member&&this.member.id){
                        this.payItem.member=this.member
                    }
                    if(mcId){
                        this.payItem.cardId=mcId
                    }
                    this.jsShow=true
                } else {
                    this.$notify("没添加任何商品!");
                    return;
                }
            },
            gbPay(){
                this.jsShow = false
            },


            toItemChoose(data) {
                this.items.push(data.item)
                this.total = parseFloat(this.total) + parseFloat(data.total)

            },

            toSkuChoose(data) {
                this.skus.push(data.item)
                this.total = parseFloat(this.total) + parseFloat(data.total)
            },
            toSpecChoose(data) {
                this.specs.push(data.item)
                this.total = parseFloat(this.total) + parseFloat(data.total)
            },

            guanbi(item) {
                this.items.push(item)
                this.tcShow = false
                this.scShow = false
            },

            initMbCard(mc){
                if (this.$refs.itemTab){
                    this.$refs.itemTab.qiehuan(mc);
                }
                if (this.$refs.skuTab){
                    this.$refs.skuTab.qiehuan(mc);
                }
            },
            sankejiage(){
                this.initMbCard()
                //切换到散客
                var total = 0;
                this.items.forEach(item => {
                    this.setItemPrice('SK',item)
                })
                this.skus.forEach(item => {
                    this.setSkuPrice('SK',item)
                })
                this.hjTotal()
            },

            huiyuanjiage(){
                this.initMbCard(this.mbCard)
                //切换到会员卡
                this.items.forEach(item => {
                    this.setItemPrice('HY',item,this.mbCard)
                })
                this.skus.forEach(item => {
                    this.setSkuPrice('HY',item,this.mbCard)
                })
                this.hjTotal()
            },
            //切换散客/会员卡计算价格 项目
            setItemPrice(type,item,mc) {
                //散客价格
                if (type=='SK'){
                    item.price=item.oglPrice
                }
                //会员价
                if (type=='HY'){
                    if (item.discount == 1) {
                        let vips=false
                        if (item.itemVips.length > 0) {
                            item.itemVips.forEach(vip => {
                                if (vip.cardId == mc.cardId) {
                                    item.price = vip.vipPrice;
                                    vips=true
                                }
                            })
                        }
                        if (!vips){
                            if (mc.itemDiscount > 0) {
                                item.price = this.calculationPrice(item.price, mc.itemDiscount)
                            }
                        }
                    }
                }
            },

            //切换散客/会员卡计算价格 卖品
            setSkuPrice(type,item,mc) {
                //散客价格
                if (type=='SK'){
                    item.price=item.oglPrice
                }
                //会员价
                if (type=='HY'){
                    if (mc.skuDiscount > 0) {
                        item.price = this.calculationPrice(item.price, this.mc.skuDiscount)
                    }
                }
            },
            hjTotal(){
                let itemTotal=0
                let skuTotal=0
                let specTotal=0
                this.items.forEach(item=>{
                    itemTotal=parseFloat(itemTotal) + parseFloat(item.price)
                })
                this.skus.forEach(item=>{
                    skuTotal=parseFloat(skuTotal) + parseFloat(item.price)
                })
                this.specs.forEach(item=>{
                    itemTotal=parseFloat(specTotal) + parseFloat(item.price)
                })
                let total=parseFloat(itemTotal) + parseFloat(skuTotal) + parseFloat(specTotal)
                this.total=total.toFixed(1)
            },


            //计算价格
            calculationPrice(num1, num2) {
                var num = parseFloat(num1 * num2 / 10)
                return num.toFixed(1);
            },
            //计算价格
            setPrice(item) {
                item.price = item.oglPrice
                if (item.discount == 1) {
                    if (this.mbCard && this.mbCard.id) {
                        if (item.itemVips.length > 0) {
                            item.itemVips.forEach(vip => {
                                if (vip.cardId == this.mbCard.cardId) {
                                    item.price = vip.vipPrice;
                                }
                            })
                        } else {
                            //计算会员价
                            if (this.mbCard.itemDiscount != 0) {
                                item.price = this.calculationPrice(item.price, this.mbCard.itemDiscount)
                            }
                        }
                    }
                }
            },
            toXfs(){
                if (this.member&&this.member.id){
                    this.$router.push('/fwMdCmp?memberId='+this.member.id)
                }
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    /deep/ .el-card__header {
        padding: 10px;
        border-bottom: 0.02667rem solid #EBEEF5;
        box-sizing: border-box;
        font-size: 13px;
    }

    /deep/ .el-card__body {
        padding: 10px;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff;
        border-radius: 0px;
        border-bottom-color: #EEEEEE;
    }

</style>
